export default __webpack_public_path__ + "static/media/warning--steep-ascent-and-descent--g1.127e8fa0.png";